<template>
  <div>
    Network issue. Please try again <hr>
    <router-link :to="{name: 'Home'}">Home page</router-link>
  </div>
</template>

<script>
export default {

}
</script>